module.exports = __webpack_public_path__ + "img/jiaowu_mobile2.50038d52.jpg";